import React from 'react';
import { Circle } from 'lucide-react';
import { shortcutLabelString } from '../../config/shortcuts';

/**
 * The action sub-menu (PLAN §2.5, mockup "Action sub-menu on a task"):
 * `role="menu"` beside the list; focus stays in the input and
 * `aria-activedescendant` moves into the menu (§2.7). [0] is the Enter default.
 */
export default function PaletteActions({ menuId, title, actions, activeIndex, onHover, onRun, t }) {
  return (
    <div className="palette-actions" role="menu" id={menuId} aria-label={t('palette.actions.label', { name: title })}>
      <div className="palette-actions-title">{title}</div>
      {actions.map((a, i) => {
        const Icon = a.icon || Circle;
        const active = i === activeIndex;
        return (
          <div
            key={a.id}
            id={`${menuId}-${i}`}
            role="menuitem"
            aria-current={active ? 'true' : undefined}
            className={`palette-action${active ? ' palette-action--active' : ''}`}
            onMouseMove={() => onHover(i)}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onRun(a)}
          >
            <Icon size={14} aria-hidden="true" />
            <span className="palette-action-title">{t(a.titleKey)}</span>
            {i === 0 ? <kbd className="palette-kbd">↵</kbd> : a.shortcut ? <kbd className="palette-kbd">{shortcutLabelString(a.shortcut)}</kbd> : null}
          </div>
        );
      })}
    </div>
  );
}
